import { render, staticRenderFns } from "./build-subject-description.view.vue?vue&type=template&id=3e5b78be&scoped=true&"
import script from "./build-subject-description.view.ts?vue&type=script&lang=ts&"
export * from "./build-subject-description.view.ts?vue&type=script&lang=ts&"
import style0 from "./build-subject-description.view.scss?vue&type=style&index=0&id=3e5b78be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5b78be",
  null
  
)

export default component.exports